<template>
	<div>
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("payments") }}</h1>
				</div>

				<div class="header_actions">
					<div class="header_actions-container">
						<option-button
							:show="true"
							:buttons="buttons"
							@clear="handleClear"
							@delete="deleting = true"
							@add="add = true"
							:csvEntity="'payments'"
							:csvHeader="csvHeader"
							:csvFilters="getFilters"
							:processCsv="processCsv"
						/>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex">
			<el-input
				v-model="filters.text"
				style="width: 40%"
				:placeholder="$t('search-something')"
				clearable
				@keyup.enter.native="handleSearch(false)"
				@input="handleChange"
			/>
			<el-select
				style="width: 60%"
				v-model="filters.subscriptions"
				multiple
				clearable
				filterable
				:placeholder="$t('select-subscriptions')"
				:collapse-tags="filters.subscriptions.length > 4"
				value-key="name"
				@change="handleChange"
			>
				<el-option v-for="item in subscriptions" :value="item" :key="item.id" :label="item.name">
					<div style="display: flex; width: 100%">
						<span>{{ item.name }}</span>
						<span style="color: gray; margin-left: auto; margin-rigth: 0">{{
							item.duration_month + " " + $t("month")
						}}</span>
					</div>
				</el-option>
			</el-select>
			<el-select
				style="width: 60%"
				v-model="filters.status"
				multiple
				clearable
				filterable
				:placeholder="$t('select-status')"
				:collapse-tags="filters.status.length > 4"
				value-key="name"
				@change="handleChange"
			>
				<el-option v-for="item in status" :value="item" :key="item.id" :label="item.name">
					<div style="display: flex; width: 100%">
						<span>{{ item.name }}</span>
					</div>
				</el-option>
			</el-select>
			<el-date-picker
				@change="handleChange"
				v-model="filters.dates"
				type="daterange"
				:start-placeholder="this.$t('from')"
				:end-placeholder="this.$t('to')"
				format="dd/MM/yyyy"
				unlink-panels
			/>
			<el-button
				type="primary"
				@click="handleSearch(false)"
				style="width: 75px; margin-left: auto; margin-right: 0"
			>
				<i class="el-icon-search" />
			</el-button>
			<el-button
				v-if="searching"
				type="warning"
				@click="handleSearch(true)"
				style="width: 75px; margin-left: auto; margin-right: 0"
			>
				<i class="el-icon-close" />
			</el-button>
		</div>
		<div>
			<div :style="{ height: height + 'px' }" style="overflow-y: auto">
				<div v-loading="!deleting && loading">
					<payments-table @fetch="doFetch" :selecteds="selecteds" />
				</div>
			</div>
		</div>

		<div v-if="add">
			<payments-add :show="add" @close="add = false" @add="handleAdd" />
		</div>

		<div v-if="deleting">
			<delete-confirm-modal
				@close="handleDelete"
				:loading="loading"
				:title="$t('confirmation-delete-title')"
				:content="$t('confirmation-delete-text')"
			/>
		</div>
	</div>
</template>
<script>
import axios from "axios"
import { mapActions, mapGetters } from "vuex"
import { exportTableToCSV, downloadCSV } from "@/utils/utils"
import moment from "moment"
import AddButton from "@/modules/_common/button/add-button.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"
import PaymentsAdd from "@/modules/users/payments/payments-components/payments-add.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"
import PaymentsTable from "./form/payments-table.vue"

export default {
	components: {
		OptionButton,
		AddButton,
		PaymentsAdd,
		DeleteConfirmModal,
		PaymentsTable
	},
	name: "payments-list",
	data() {
		return {
			height: window.innerHeight - 300,
			add: false,
			loading: true,
			selecteds: [],
			buttons: ["add", "option", "option-csv"],
			searching: false,
			filters: {
				text: undefined,
				dates: undefined,
				subscriptions: [],
				status: []
			},
			subscriptions: [],
			status: [
				{
					id: "waiting",
					name: this.$t("waiting")
				},
				{
					id: "active",
					name: this.$t("active")
				},
				{
					id: "expired",
					name: this.$t("expired")
				}
			],

			//CSV
			csvHeader: [
				this.$t("id"),
				this.$t("organization") + " " + this.$t("id"),
				this.$t("organization"),
				this.$t("subscription") + " " + this.$t("id"),
				this.$t("subscription"),
				this.$t("price"),
				this.$t("currency"),
				this.$t("valid-until"),
				this.$t("valid-from"),
				this.$t("created-at"),
				this.$t("updated-at")
			],

			deleting: false
		}
	},
	computed: {
		...mapGetters({
			payments: "payment/payments"
		})
	},
	created() {
		this.doFetch()
		axios
			.get(process.env.VUE_APP_API_URL + "/api/subscriptions", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				this.subscriptions = res.data
			})
			.catch(err => console.error(err))
	},
	watch: {
		selecteds: function () {
			if (this.selecteds.length > 0) {
				this.buttons = ["delete", "clear"]
			} else {
				this.buttons = ["add", "option", "option-csv"]
				this.loading = false
				this.selected = undefined
				this.show_details = false
			}
		}
	},
	methods: {
		moment,
		exportTableToCSV,
		downloadCSV,
		...mapActions({
			doGetByFilters: "payment/doGetByFilters",
			doMutate: "payment/doMutate",
			doDelete: "payment/doDelete"
		}),
		rowClick: function (item) {
			this.doMutate({ element: "payment", value: item })
			this.$router.replace({ path: "/users/payments/" + item.id })
		},

		handleClear: function () {
			this.selecteds = []
		},

		handleAdd: function (item) {
			this.array.push(item)
			this.add = false
			this.$notification("success", this.$t("save-successful"), "", 4000)
		},

		handleDelete: function (value) {
			if (!value) {
				this.deleting = false
				return
			}
			var array = []
			if (this.selecteds.length == 0 && this.selected != undefined) array = [this.selected]
			else array = this.selecteds

			this.loading = true
			this.show_details = false

			this.delete(array)
		},

		async delete(array) {
			var r = await this.doDelete(array)

			if (r.status) {
				this.$notification("success", this.$t("deleted-successfully"), "", 4000)
			} else {
				this.$processError(this.$t("delete-error"), r.msg)
			}

			this.loading = false
			this.show_details = false
			this.selected = undefined
			this.deleting = false
		},

		handleUpdate: function (value) {
			this.array.forEach((el, index) => {
				if (el.id == value.id) this.array[index] = value
			})
		},

		handleSearch: function (reset) {
			this.searching = !reset

			if (!this.searching) {
				this.filters.text = ""
				this.filters.dates = []
				this.filters.subscriptions = []
				this.filters.status = []
			}

			this.doFetch()
		},

		handleChange: function () {
			if (this.searching) this.searching = false
		},

		doFetch: function (pagination) {
			var filters = this.getFilters(true, pagination)
			this.loading = true
			this.getList(filters)
		},

		async getList(filters) {
			await this.doGetByFilters(filters)
			this.loading = false
		},

		getFilters(withFilters, pagination = { size: 50, offset: 0 }) {
			if (!withFilters)
				return {
					organization: "",
					valid_from: undefined,
					valid_until: undefined,
					status: [],
					subscriptions: [],
					pagination: {},
					now: new Date()
				}

			var filters = {
				organization: this.filters.text ? this.filters.text : "",
				valid_from: this.filters.dates && this.filters.dates.length > 0 ? this.filters.dates[0] : undefined,
				valid_until: this.filters.dates && this.filters.dates.length > 1 ? this.filters.dates[1] : undefined,
				status: [],
				subscriptions: [],
				pagination: {},
				now: new Date()
			}

			this.filters.subscriptions.forEach(item => {
				filters.subscriptions.push(item.id)
			})

			this.filters.status.forEach(item => {
				filters.status.push(item.id)
			})

			filters.pagination.offset = pagination.offset
			filters.pagination.size = pagination.size

			return filters
		},
		processCsv: function (item) {
			var data = []

			data.push("id: " + item.id)

			data.push("id: " + item.organization_id)
			data.push('"' + item.organization.name.String.replace(/"/g, '""') + '"')

			data.push("id: " + item.subscription_id)
			data.push('"' + item.subscription.name.replace(/"/g, '""') + '"')

			data.push(item.amount)
			data.push(item.currency)

			data.push(item.valid_from ? moment(item.valid_from).format("DD/MM/YYYY HH:mm:ss") : "-")
			data.push(item.valid_until ? moment(item.valid_until).format("DD/MM/YYYY HH:mm:ss") : "-")

			data.push(moment(item.created_at).format("DD/MM/YYYY HH:mm:ss"))
			data.push(item.updated_at ? moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss") : "-")

			return data
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-tab.scss";
</style>
